var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "encyclopeDias marginAuto" },
    [
      _c("TopNavigation", { attrs: { TopAct: "3" } }),
      _c(
        "div",
        { class: this.$store.state.webNavigator == "pc" ? "" : "pan110" },
        [
          _c("listTopImg", { attrs: { imgType: "2" } }),
          _c(
            "div",
            {
              staticClass: "marginAuto",
              class: this.$store.state.webNavigator == "pc" ? "max1720" : ""
            },
            [
              _c(
                "div",
                [
                  _c("videoPage", {
                    key: _vm.keys,
                    attrs: {
                      listType: _vm.informationType ? _vm.informationType : "",
                      classType: "A8",
                      active: _vm.types,
                      pageIndex: _vm.current,
                      pageType: true,
                      toLeveListPath: _vm.toLeveListPath
                    },
                    on: { getTotal: _vm.getTotal }
                  }),
                  _c("Pagination", {
                    key: _vm.pageKey,
                    attrs: {
                      total: _vm.total,
                      display: 9,
                      "current-page": _vm.current
                    },
                    on: { pagechange: _vm.getPage }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("FooterNavigation")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ad1dd74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ad1dd74","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/encyclopeDias/encyclopeDias.vue
// module id = 1190
// module chunks = 7